/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 *
 * I&C Monitors and Advisors (ICMA)
 */
import React from 'react';

export default class LoadingComponent extends React.Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    return (
      <React.Fragment>
        <div className="dls-lp-loader "></div>
        <div className={`modal-window ${this.props.customLoader}`}></div>
      </React.Fragment>
    );
  }
}
